export var CaseRoles;
(function (CaseRoles) {
    CaseRoles["admin"] = "29";
    CaseRoles["collaborator"] = "30";
    CaseRoles["reader"] = "31";
    CaseRoles["helpdesk"] = "32";
    CaseRoles["globalAdmin"] = "3";
})(CaseRoles || (CaseRoles = {}));
export const allCaseRoles = Object.values(CaseRoles);
const caseRoleNames = [
    { key: CaseRoles.admin, name: "Case Admin", isApplicableToCases: true },
    { key: CaseRoles.collaborator, name: "Case Collaborator", isApplicableToCases: true },
    { key: CaseRoles.reader, name: "Case Reader", isApplicableToCases: true },
    { key: CaseRoles.helpdesk, name: "Case Helpdesk", isApplicableToCases: true },
    { key: CaseRoles.globalAdmin, name: "Global Admin", isApplicableToCases: false },
];
export const getRoleName = (role) => {
    var _a;
    return ((_a = caseRoleNames.find(r => r.key === role)) === null || _a === void 0 ? void 0 : _a.name) || "";
};
export const getRoleNames = (roles) => {
    return roles.map(role => { var _a; return ((_a = caseRoleNames.find(r => r.key === role)) === null || _a === void 0 ? void 0 : _a.name) || ""; });
};
export const getAssignableRolesList = () => {
    return caseRoleNames
        .filter(role => role.isApplicableToCases)
        .map(role => ({ id: role.key, name: role.name }));
};
export const getCaseRolesFromUserRoleStrings = (roleString) => {
    return roleString
        .filter(roleString => allCaseRoles.includes(roleString.toString()))
        .map(roleString => roleString.toString());
};
